import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { TagService } from '../_services';
import * as TagActions from '../_actions/tag';

@Injectable({
  providedIn: 'root',
})
export class TagEffects {
  loadTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagActions.loadTags),
      mergeMap(() =>
        this.tagService.getTags().pipe(
          map((tags) => TagActions.loadTagsSuccess({ tags })),
          catchError((error) => of(TagActions.loadTagsFailure({ error })))
        )
      )
    )
  );

  addTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagActions.addTag),
      mergeMap(({ tag }) =>
        this.tagService.saveTag(tag).pipe(
          map((savedTag) => TagActions.addTagSuccess({ tag: savedTag })),
          catchError((error) => of(TagActions.addTagFailure({ error })))
        )
      )
    )
  );

  updateTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagActions.updateTag),
      mergeMap(({ tag }) =>
        this.tagService.saveTag(tag).pipe(
          map((updatedTag) => TagActions.updateTagSuccess({ tag: updatedTag })),
          catchError((error) => of(TagActions.updateTagFailure({ error })))
        )
      )
    )
  );

  deleteTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TagActions.deleteTag),
      mergeMap(({ id }) =>
        this.tagService.deleteTag(id).pipe(
          map(() => TagActions.deleteTagSuccess({ id })),
          catchError((error) => of(TagActions.deleteTagFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private tagService: TagService
  ) {}
}
